// extracted by mini-css-extract-plugin
export default {"Calendar":"MP8exi5nJt6birpVFLkp","Variant--rounded":"FzTQeaAI4e5ZGDPgJ_oQ"};